export const API_ROUTES = {
  PAYMENT_PUBLISHABLE_KEY: {
    METHOD: 'GET',
    URL: 'payment/publishable-key',
  },
  PUBLIC_PAYMENT_LINK_PUBLISHABLE_KEY: {
    METHOD: 'GET',
    URL: 'public/payment-link/publishable-key',
  },
  STRIPE_PAYMENT: {
    METHOD: 'POST',
    URL: 'stripe/charge',
  },
  CREATE_STRIPE_INTENT: {
    METHOD: 'POST',
    URL: 'stripe/create-intent',
  },
  CUSTOMER_DASHBOARD: {
    METHOD: 'GET',
    URL: 'dashboard',
  },
  PROVIDER_DASHBOARD: {
    METHOD: 'POST',
    URL: 'user/dashboard',
  },
  PROVIDER_DASHBOARD_CDR_STATS: {
    METHOD: 'POST',
    URL: 'user/dashboard/cdr-stats',
  },
  DASHBOARD_STATS: {
    METHOD: 'POST',
    URL: 'user/dashboard/stats',
  },
  DASHBOARD_EXPORT: {
    METHOD: 'POST',
    URL: 'user/dashboard/export',
  },
};
